import request from '../utils/request'


export function index(params) {
  	return request({
  	  url: '/patientIndicatorIndeces',
  	  method: 'get',
      params
  	})
  }
  export function inventory(params) {
    return request({
      url: '/patientIndicatorIndeces/inventory',
      method: 'get',
      params
    })
  }
  export function show(id) {
    return request({
      url: `/patientIndicatorIndeces/${id}`,
      method: 'get'
    })
  }
  export function store(data) {
    return request({
      url: '/patientIndicatorIndeces',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/patientIndicatorIndeces/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/patientIndicatorIndeces/${id}`,
      method: 'delete',
    })
  }
